module.exports = __webpack_public_path__ + "img/shape-3-gold@2x.6f1396e8.png";